import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import exportIcon from 'assets/img/icons/export.svg';
import moment from 'moment';
import Loader from 'features/Loader/Loader';
import OverviewContainer from './OverviewContainer';
import './overview.scss';
import { getWorkoutLogs } from './ducks/OverviewActions';

import { getClient } from '../../../ducks/clientProfileActions';

const ProgramOverview = ({
  client,
  workoutLogs,
  getWorkoutLogs,
  loadingClient,
  loadingWorkoutLogs,
  history,
  getClient,
  ...props
}) => {
  const clientId = props.match.params.client_id;
  const [table, setTable] = useState([]);
  useEffect(() => {
    getClient(clientId, history);
    getWorkoutLogs(clientId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  const setTableTemp = value => {
    table.push(value);
    const newTable = table.map(temp => temp);
    setTable(newTable);
  };

  if (loadingClient || loadingWorkoutLogs) {
    return(<Loader/>);
  }
  return (
    <div className="program-overview">
      <div className="overview-head">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${clientId}`}>
              {client && `${ client.first_name}  ${client.last_name}`}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Program Overview</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div className="container">
        <div className="page-title">
          <h4>PROGRAM OVERVIEW</h4>
          <div className="title-action">
            <CSVLink 
              data={table}
              filename={`POV_${client?.first_name || ''}_${client?.last_name || ''}_${moment().format('MM-DD-YYYY')}.csv`}
            >
              <img src={exportIcon} alt="download" />
            </CSVLink>
          </div>
        </div>
        <OverviewContainer
          clientId={clientId}
          setTableTemp={setTableTemp}
          workoutLogs={workoutLogs}
          table={table}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    workoutLogs: state.overviewReducer.workoutLogs,
    loadingWorkoutLogs: state.overviewReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getWorkoutLogs: clientId => dispatch(getWorkoutLogs(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramOverview);
